export default {
  allWeek: 'Die ganze Woche',
  allDay: 'Den ganzen Tag',
  noDays: 'Keine Tage ausgewählt',
};
